import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import { SelectListDto } from "../../models";
import { useGetEducationSystemSelectListQuery } from "../../store/api/educationSystemApi";

type EducationSystemOption = { value: string; label: string };

type TProps = {
  isMulti?: boolean;
  closeMenuOnSelect?: boolean;
  value: EducationSystemOption | EducationSystemOption[] | null;
  onChange: (values: any) => void;
  placeholder: string;
};

export const EducationSystemsSelect: React.FC<TProps> = ({
  onChange,
  value,
  closeMenuOnSelect = true,
  isMulti = false,
  placeholder,
}) => {
  const { t, i18n } = useTranslation();

  const { data, error, isSuccess } = useGetEducationSystemSelectListQuery();
  const [options, setOptions] = useState<EducationSystemOption[]>([]);

  useEffect(() => {
    if (error) {
      const errMsg =
        "status" in error
          ? (error.data as any)?.message || "An error occurred"
          : "An error occurred";
      toast.error(errMsg, {
        autoClose: 3000,
      });
    }
  }, [error]);

  useEffect(() => {
    if (isSuccess && data) {
      const mappedOptions = data?.map((item: SelectListDto) => {
        return {
          label: i18n.language === "ar" ? item.value.ar : item.value.en,
          value: item.id,
        };
      });
      setOptions(mappedOptions);
    }
  }, [data, isSuccess, i18n.language]);

  return (
    <Select
      placeholder={t(placeholder)}
      closeMenuOnSelect={closeMenuOnSelect}
      value={value}
      onChange={onChange}
      isMulti={isMulti}
      options={options}
    />
  );
};
